module.exports = __webpack_public_path__ + "img/mute.fdf21a75.svg";